import { useEffect, useState } from 'react';
import { useAuth } from '@frontend/auth';
import { COMPANY_VERIFICATION_STATUS } from '@frontend/api';

export const useBannerNotifications = () => {
  const { currentUser, isFirstTimeEmailVerification } = useAuth();

  const [newBannerNotificationsCount, setNewBannerNotificationCount] =
    useState(0);

  const isCompanyBanner = currentUser
    ? currentUser.company.verificationStatus !==
      COMPANY_VERIFICATION_STATUS.APPROVED
    : false;

  const isEmailVerificationBanner = currentUser
    ? !currentUser.emailVerified || isFirstTimeEmailVerification
    : false;

  useEffect(() => {
    let count = 0;
    if (isEmailVerificationBanner) count += 1;
    if (isCompanyBanner) count += 1;
    setNewBannerNotificationCount(count);
  }, [isEmailVerificationBanner, isCompanyBanner]);

  return {
    newBannerNotificationsCount,
    isEmailVerificationBanner,
    isCompanyBanner,
  };
};
